import { createAction, props } from '@ngrx/store';

import { Vehicle, VehicleTypeDetail } from '@fc-core';
import { VehicleStats } from '../../service/vehicle-statistics-api.service';

export const getVehicleStats = createAction(
  '[VehiclesDetail] Get Vehicle Stats',
  props<{ vehicleId: number }>(),
);
export const getVehicleStatsSuccess = createAction(
  '[VehiclesDetail] Get Vehicle Stats Success',
  props<{ vehicleStats: VehicleStats }>(),
);

export const getVehicleTypeDetails = createAction(
  '[VehiclesDetail] Get Vehicle Type Details',
  props<{ vehicleType: number }>(),
);
export const getVehicleTypeDetailsSuccess = createAction(
  '[VehiclesDetail] Get Vehicle Type Details Success',
  props<{ typeDetail: VehicleTypeDetail }>(),
);

export const addSpecToVehicle = createAction(
  '[VehiclesDetail] Add spec to vehicle',
  props<{ specsSchema: any; vehicle: Vehicle; specName: string }>(),
);

export const deleteSpecFromVehicle = createAction(
  '[VehiclesDetail] Delete spec from vehicle',
  props<{ vehicle: Vehicle; specName: string }>(),
);

export const addSpecToVehicleError = createAction(
  '[VehiclesDetail] Add spec to vehicle Error',
  props<{ error: any }>(),
);

export const addSpecToVehicleSuccess = createAction(
  '[VehiclesDetail] Add spec to vehicle success',
  props<{ vehicle: Vehicle }>(),
);
